// src/menu/menuData.jsx
import { useContext } from "react";
import { AuthContext } from "@/auth/AuthContext";

// Optional: A wrapper component if you want to dynamically filter or log based on user
const useMenuData = () => {
  const { user } = useContext(AuthContext);
  let menuData = [
    {
      title: "Home",
      path: "/",
    },
    {
      title: "Location",
      path: "/location",
    },
    {
      title: "Panel User",
      path: "/panel-user",
    },
    {
      title: "Panel Variable",
      path: "/panel-variable",
    },
    {
      title: "Panelist Quality",
      path: "/panelist-quality",
    },
    {
      title: "Global Settings",
      submenu: [
        { title: "User Account", path: "/user-account" },
        { title: "Application Access Manager", path: "/access-manager" },
        { title: "Points", path: "/points" },
        { title: "Referral", path: "/referral" },
        { title: "Communication Channels", path: "/survey-history" },
        { title: "Help & Support", path: "/support" },
        { title: "Transaction History", path: "/transaction" },
        { title: "Redeem", path: "/redeem" },
        { title: "Join Source", path: "/join-source" },
        { title: "User Bio", path: "/user-bio" },
      ],
    },
  ];

  let menuData2 = [
    {
      title: "Home",
      path: "/",
    },
    {
      title: "Location",
      path: "/location",
    },
    {
      title: "Panel User",
      path: "/panel-user",
    },
    {
      title: "Panel Variable",
      path: "/panel-variable",
    },
    {
      title: "Panelist Quality",
      path: "/panelist-quality",
    },
  ];


  if (user?.roleId == 1) {
    return menuData;
  }
  if (user?.roleId == 2 || user?.roleId == 3) {
    return menuData2;
  }
  
};

export default useMenuData;
